import React from 'react';
import { Admin, Resource, Delete } from 'admin-on-rest';

import rootReducer from './reducers/rootReducer';
import rootSaga from './sagas/rootSaga';

import {RestClient} from './RestClient';
import AuthClient from './AuthClient';

import customRoutes from './routes/customRoutes';

import dashboard from './pages/dashboard/dashboard';
import { UsersList, UserEdit, UserCreate } from './pages/users/users';
import { DevicesList, DeviceEdit, DeviceCreate } from './pages/devices/devices';
import loginPage from './pages/login/login';

import Menu from './common/components/Menu/Menu'

import UserIcon from 'material-ui/svg-icons/social/group';
import DeviceIcon from 'material-ui/svg-icons/hardware/cast';

import {USER_ROLE_TITLE} from "./util/util";

import CustomLayout from "./common/components/CustomLayout/CustomLayout";

const App = () => (
  <Admin
    appLayout={CustomLayout}
    menu={Menu}
    restClient={RestClient}
    authClient={AuthClient}
    customRoutes={customRoutes}
    dashboard={dashboard}
    loginPage={loginPage}
    customReducers={{rootReducer}}
    customSagas={[rootSaga]}>
    {permissions => [
      permissions === (USER_ROLE_TITLE.ADMIN) ? <Resource name="users" list={UsersList} edit={UserEdit} create={UserCreate} remove={Delete} icon={UserIcon} /> : null,
      permissions === (USER_ROLE_TITLE.ADMIN) ? <Resource name="devices" list={DevicesList} edit={DeviceEdit} create={DeviceCreate} remove={Delete} icon={DeviceIcon} /> : null
    ]}
  </Admin>
);

export default App;


// WEBPACK FOOTER //
// ./src/App.js